import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes"];
import React from 'react';
import PropTypes from 'prop-types';
import { default as withStyles } from '../styles';
import { default as MuiPaper } from '@mui/material/Paper';
var styles = function styles() {
  return {
    root: {}
  };
};

/**
 * A component that is the basis for many of other components.
 * @done true
 * @updated v7.0.0
 * @versionAdded v0.0.11
 */
var Paper = /*#__PURE__*/React.forwardRef(function (props, ref) {
  var classes = props.classes,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var classOverrides = _extends({
    root: classes.root
  }, classes);
  return /*#__PURE__*/React.createElement(MuiPaper, _extends({}, rest, {
    classes: classOverrides,
    ref: ref
  }));
});
Paper.muiName = 'Paper';
Paper.displayName = 'Paper';
Paper.propTypes = {
  /**
   * The content of the component.
   */
  children: PropTypes.node,
  /**
   * Override or extend the styles applied to the component.
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * The component used for the root node.
   * Either a string to use a DOM element or a component.
   */
  component: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
  /**
   * Shadow depth, corresponds to `dp` in the spec.
   * It's accepting values between 0 and 24 inclusive.
   */
  elevation: PropTypes.number,
  /**
   * If `true`, rounded corners are disabled.
   */
  square: PropTypes.bool,
  /**
   * The system prop that allows defining system overrides as well as additional CSS styles.
   * See the `sx` page for more details.
   */
  sx: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.oneOfType([PropTypes.func, PropTypes.object, PropTypes.bool])), PropTypes.func, PropTypes.object]),
  /**
   * @ignore
   * The variant to use.
   */
  variant: PropTypes.oneOfType([PropTypes.oneOf(['elevation', 'outlined']), PropTypes.string])
};
Paper.defaultProps = {
  component: 'div',
  elevation: 2,
  square: false
};
export default withStyles(styles)(Paper);